// @flow
import React, { useContext } from 'react';

import { useRouter } from 'Client/router/useRouter';
import ReactAppContext from 'Context/ReactAppContext';
import { isSeller } from 'Utils/seller/sellerUtils';
import { getConfigWithNoThirdPartySupport } from './thirdParty.utils';

export const Jivochat = () => {
  const {
    location: { queryParams },
  } = useRouter<{}, GlobalQueryParams>();
  const appContext = useContext(ReactAppContext);
  const jivochat = getConfigWithNoThirdPartySupport({
    name: 'jivochat',
    locale: appContext.locale,
    queryParams,
  });

  if (!isSeller(appContext) && jivochat.enabled && jivochat.id) {
    return (
      <script
        async
        type="text/javascript"
        src={`//code.jivosite.com/script/widget/${jivochat.id}`}
      />
    );
  }

  return null;
};
